import { getMorkhasiInfo, getMorkhasiHistory } from "@/api/morkhasi";
export default {
    state: {
        morkhasiInfo: [],
        history: [],
    },

    mutations: {
        SET_MORKHASI_INFO: (state, data) => {
            state.morkhasiInfo = data;
        },
        SET_MORKHASI_HISTORY: (state, data) => {
            state.history = data;
        },
    },

    actions: {
        getMorkhasiInfo({ commit }) {
            return new Promise((resolve, reject) => {
                getMorkhasiInfo()
                    .then((response) => {
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        commit("SET_MORKHASI_INFO", data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getMorkhasiHistory({ commit }) {
            commit("SET_TABLE_TEXT", true);
            return new Promise((resolve, reject) => {
                getMorkhasiHistory()
                    .then((response) => {
                        if (!response.data) {
                            reject("error");
                        }
                        const data = response.data;;
                        commit("SET_MORKHASI_HISTORY", data);
                        commit("SET_TABLE_TEXT", false);

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};